import React from "react";
import { useOutletContext, Link } from "react-router-dom";

export default function Research() {
  const { profile } = useOutletContext() || {};
  const interests = profile?.research_interests || [];
  return (
    <div data-testid="research-page">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 block-print-pattern opacity-40 pointer-events-none" />
        <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20">
          <p className="text-xs tracking-[0.3em] uppercase text-[#C24D2C]">Research</p>
          <h1 className="mt-4 font-serif-display text-5xl lg:text-6xl text-[#1A2456] font-bold max-w-4xl">
            Inquiry that begins in <span className="italic text-[#E35D29]">the village</span>, informs the academy.
          </h1>
          <p className="mt-8 max-w-2xl text-[#5C544F] leading-relaxed text-lg">
            My research foregrounds lived experience — combining qualitative fieldwork with policy analysis to
            generate practical insights for rural development and community empowerment.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pb-24">
        <h2 className="font-serif-display text-3xl text-[#1A2456]">Areas of focus</h2>
        <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {(interests.length ? interests : ["Rural Development", "Community Extension", "Sustainable Agriculture"]).map(
            (r, i) => (
              <div
                key={r}
                data-testid={`research-area-${i}`}
                className="border border-[#D8CFC4] bg-white p-8 card-lift"
              >
                <span className="font-serif-display text-5xl text-[#E35D29]">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-4 font-serif-display text-xl text-[#1A2456]">{r}</h3>
                <p className="mt-2 text-sm text-[#5C544F]">
                  Explored through fieldwork, participatory action research and policy engagement.
                </p>
              </div>
            )
          )}
        </div>

        <div className="mt-16 bg-[#F5EFE6] p-10 lg:p-14 border-l-4 border-[#E35D29]">
          <p className="font-serif-display italic text-2xl lg:text-3xl text-[#1A2456] leading-relaxed">
            “The strongest scholarship listens first. Every paper begins with a conversation under a neem tree.”
          </p>
          <p className="mt-6 text-xs tracking-[0.3em] uppercase text-[#C24D2C]">— Dr. Ruchi Singh</p>
        </div>

        <div className="mt-16 flex flex-wrap gap-4">
          <Link
            to="/publications"
            data-testid="research-cta-publications"
            className="bg-[#1A2456] text-white px-7 py-4 hover:bg-[#10163A] transition-colors"
          >
            See Publications
          </Link>
          <Link
            to="/contact"
            data-testid="research-cta-collab"
            className="border border-[#C24D2C] text-[#C24D2C] px-7 py-4 hover:bg-[#C24D2C] hover:text-white transition-colors"
          >
            Propose a Collaboration
          </Link>
        </div>
      </section>
    </div>
  );
}
